import React from 'react';
import { 
  MapPin, 
  ArrowUpRight, 
  HardHat, 
  Zap, 
  Wind, 
  Hammer, 
  Ruler, 
  Briefcase 
} from 'lucide-react';
import styles from './AvailableJobs.module.css';

const JobCard = ({ title, description, address, type, onClick }) => {
  
  // Helper to select icon based on job title or type
  const getIcon = () => {
    const t = (type || title || '').toLowerCase();
    if (t.includes('architect')) return <Ruler size={28} />;
    if (t.includes('electric')) return <Zap size={28} />;
    if (t.includes('air') || t.includes('hvac')) return <Wind size={28} />;
    if (t.includes('build') || t.includes('carpenter')) return <HardHat size={28} />;
    if (t.includes('plumber')) return <Hammer size={28} />;
    return <Briefcase size={28} />; // Default
  };

  // Safe split for address to handle potential undefined values
  const formatAddress = (addr) => {
    if (!addr) return '';
    return addr.split(',').map((part, index, arr) => (
      <span key={index}>
        {part}{index < arr.length - 1 ? ',' : ''}
        {index < arr.length - 1 && <br />}
      </span>
    ));
  };

  return (
    <article className={styles.card} onClick={onClick}>
      <div className={styles.cardHeader}>
        <div className={styles.iconWrapper}>
          {getIcon()}
        </div>
        <h2 className={styles.cardTitle}>{title}</h2>
      </div>
      
      <p className={styles.description}>{description}</p>
      
      <div className={styles.cardFooter}>
        <div className={styles.locationWrapper}>
          <MapPin className={styles.locationIcon} />
          <p className={styles.locationText}>
             {formatAddress(address)}
          </p>
        </div>
        <ArrowUpRight className={styles.arrowIcon} size={24} />
      </div>
    </article>
  );
};

export default JobCard;